import _createClass from '@babel/runtime/helpers/esm/createClass';

/* eslint-disable */
import ExpressionQuery from './ExpressionQuery';

var SearchObject = /*#__PURE__*/function () {
  function SearchObject(searchObject) {
    if (searchObject) {
      this._expression = searchObject.expression.map(function (exp) {
        return new ExpressionQuery(exp);
      });
    }
  }

  var _proto = SearchObject.prototype;

  _proto.getSearchObjectObjectification = function getSearchObjectObjectification() {
    var ret = {};

    if (this._expression) {
      if (this._expression.length === 0) {
        ret.expression = [];
      } else {
        ret.expression = this._expression.map(function (exp) {
          return exp.getExpressionQueryObjectification();
        });
      }
    }

    return ret;
  };

  _createClass(SearchObject, [{
    key: 'expression',
    get: function get() {
      return this._expression;
    },
    set: function set(val) {
      this._expression = val.map(function (v) {
        return new ExpressionQuery(v);
      });
    }
  }]);

  return SearchObject;
}();

export { SearchObject as default };